import { render, staticRenderFns } from "./NewSalesDocumentPage.vue?vue&type=template&id=46b395da&scoped=true"
import script from "./NewSalesDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewSalesDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b395da",
  null
  
)

export default component.exports